module.exports = __webpack_public_path__ + "static/media/tada_driver_privacy_zh-TW_HK.e93c4468.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/tada_driver_privacy_zh-TW_HK.md
// module id = 81
// module chunks = 0